import { render } from "./visiMisi.vue?vue&type=template&id=487332b6"
import script from "./visiMisi.vue?vue&type=script&lang=js"
export * from "./visiMisi.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__